module.exports = __webpack_public_path__ + "static/media/university-3.b4c9fb79.png";